import axiosInstance from "../../../utils/axiosConfig";
import { compactParams } from "../../../lib/api/params";
import type { IsoDateRange } from "../../../lib/adminExport/datePresets";

export const SURVEY_EXPORT_PAGE_LIMIT = 100;
export const MAX_SURVEY_EXPORT_PAGES = 200;

export type SurveyResponse = {
  name?: string;
  email?: string;
  primaryUsage?: string;
  volumeRange?: string;
  [key: string]: unknown;
};

/** Pages through survey responses at a safe limit for CSV export. */
export async function fetchSurveyResponsesForExport(
  range?: IsoDateRange | null,
  search?: string
): Promise<SurveyResponse[]> {
  const responses: SurveyResponse[] = [];
  let totalPages = 1;

  for (let page = 1; page <= totalPages; page++) {
    if (page > MAX_SURVEY_EXPORT_PAGES) {
      throw new Error(
        `Export is limited to ${
          MAX_SURVEY_EXPORT_PAGES * SURVEY_EXPORT_PAGE_LIMIT
        } rows. Narrow your search or date range.`
      );
    }

    const { data } = await axiosInstance.get<{ data?: unknown }>(
      "api/users/survey/responses",
      {
        params: compactParams({
          page,
          limit: SURVEY_EXPORT_PAGE_LIMIT,
          search,
          startDate: range?.startDate,
          endDate: range?.endDate,
        }),
      }
    );

    const root = (data?.data ?? {}) as {
      responses?: SurveyResponse[];
      meta?: { totalPages?: number };
    };
    const batch = Array.isArray(root.responses) ? root.responses : [];

    if (page === 1) {
      totalPages = Math.max(1, root.meta?.totalPages ?? 1);
    }

    responses.push(...batch);
    if (batch.length === 0) break;
  }

  return responses;
}
